import { Injectable } from '@angular/core';
import { Firestore, collectionData, collection, query, orderBy, DocumentData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Timestamp, where } from '@firebase/firestore';

export interface UserStats {
  label: string;
  count: number;
}

@Injectable({ providedIn: 'root' })
export class StatisticsService {
  constructor(private firestore: Firestore) {}

  private parseDate(input: any): Date {
    if (input instanceof Timestamp) {
      return input.toDate();
    } else if (typeof input === 'string' || input instanceof String) {
      return new Date(input as string);
    } else if (input instanceof Date) {
      return input;
    } else {
      return new Date(NaN);
    }
  }

  getUserRegistrations(period: 'day' | 'month' = 'day'): Observable<UserStats[]> {
    const usersRef = collection(this.firestore, 'users');
    const q = query(usersRef, orderBy('createdAt', 'asc'));

    return collectionData(q, { idField: 'id' }).pipe(
      map((data: DocumentData[]) => {
        if (period === 'day') {
          return data.map(u => {
            const date = this.parseDate(u['createdAt']);
            return {
              label: isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleDateString(),
              count: 1
            };
          });
        } else {
          const monthlyMap = new Map<string, number>();
          data.forEach(u => {
            const date = this.parseDate(u['createdAt']);
            if (!isNaN(date.getTime())) {
              const month = date.toISOString().substring(0, 7); // YYYY-MM
              monthlyMap.set(month, (monthlyMap.get(month) || 0) + 1);
            }
          });
          return Array.from(monthlyMap.entries()).map(([label, count]) => ({ label, count }));
        }
      })
    );
  }


  getTotalVisitors(): Observable<number> {
       const visitorsCollection = collection(this.firestore, 'visitors');
       return collectionData(visitorsCollection, { idField: 'id' }).pipe(
         map((documents: any[]) => {
           return documents.reduce((total, doc) => total + (doc.count || 0), 0);
         })
       );
  }

  getCllectionCount(table:string): Observable<number> {
      const usersCollection = collection(this.firestore, table);
      return collectionData(usersCollection, { idField: 'id' }).pipe(
        map((documents: any[]) => documents.length)
      );
  }
   
}
